<template>
  <v-form ref="form">
    <!-- <label :class="label">{{input.name}}</label> -->
    <v-menu v-model="menu2" :close-on-content-click="false" nudge-top="25" :nudge-left="25"
      transition="scale-y-transition" offset-y min-width="auto">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field :disabled="!type.active" :class="body" outlined dense background-color="input" :value="formattedDate" :label="`${input.name}`"
          prepend-inner-icon="mdi-calendar" :rules="rules" v-bind="attrs" v-on="on" @click:clear="input.value='', validate" :clearable="!readonly"/>
      </template>
      <v-date-picker :disabled="readonly" :min="min" v-model="input.value" @input="menu2 = false" :show-current="false"  no-title></v-date-picker>
    </v-menu>
  </v-form>
</template>

<script>
import { displayHelpers } from '@/mixins/display-helpers'

export default {
  name: 'Date',

  props: {
    dates: Array,
    input: Object,
    readonly: Boolean,
    tab: Number,
    type: Object
  },

  mixins: [displayHelpers],

  data: () => ({
    menu2: false,
    date: null
  }),

  computed: {
    rules () {
      const rules = []
      if (this.type.active && this.input.required) {
        const rule = v => !!v || `${this.input.name} Required`
        rules.push(rule)
      }
      return rules
    },

    adStartDate () {
      const date = this.dates.filter(obj => obj.group === 'AD_DATE').map(obj => obj.value)
      return date[0]
    },

    adEndDate () {
      const date = this.dates.filter(obj => obj.group === 'AD_DATE').map(obj => obj.value)
      return date[1]
    },

    tprStartDate () {
      const date = this.dates.filter(obj => obj.group === 'TPR_DATE').map(obj => obj.value)
      return date[0]
    },

    tprEndDate () {
      const date = this.dates.filter(obj => obj.group === 'TPR_DATE').map(obj => obj.value)
      return date[1]
    },

    adDateMin () {
      const min = this.adStartDate ? this.adStartDate : this.moment().add(1, 'd').format(this.$config.date_format)
      return min
    },

    tprDateMin () {
      const min = this.tprStartDate ? this.tprStartDate : this.moment().add(1, 'd').format(this.$config.date_format)
      return min
    },

    min () {
      return this.type.contract_type === 'Ad' ? this.adDateMin :
        this.type.contract_type === 'TPR' ? this.tprDateMin :
          this.moment().add(1, 'd').format(this.$config.date_format)
    },

    formattedDate () {
      return this.input.value ? this.moment(this.input.value).format(this.$config.date_display) : null
    },

    datesAllowed () {
      if (this.type.contract_type === 'Ad') {
        return this.adDatesAllowed
      } else if (this.type.contract_type === 'TPR') {
        return this.tprDatesAllowed
      } else {
        return null
      }
    },

    adDatesAllowed () {
      let adStartDates = val => ![1, 2, 3, 4, 5, 6].includes(new Date(val).getDay())
      let adEndDates = val => ![0, 1, 2, 3, 4, 5].includes(new Date(val).getDay())

      if (this.input.name === 'Start Date') {
        return adStartDates
      } else {
        return adEndDates
      }
    },

    tprDatesAllowed () {
      const tprStartDates = val => ![0, 1, 2, 3, 4, 5].includes(new Date(val).getDay())
      const tprEndDates = val => ![0, 1, 2, 3, 4, 6].includes(new Date(val).getDay())

      if (this.input.name === 'Start Date') {
        return tprStartDates
      } else {
        return tprEndDates
      }
    }
  },

  watch: {
    type: {
      deep: true,
      handler () {
        if (!this.type.active) {
          this.input.value = ''
          this.$refs.form.resetValidation()
        }
      }
    },

    tab: {
      handler () {
        this.$refs.form.validate()
      }
    }
  },

  mounted () {
    this.eventbus.$on('validateDateInputs', () => {
      const valid = this.$refs.form.validate()
      if (valid) {
        this.$emit('valid', true)
      } else {
        this.$emit('valid', false)
      }
    })
  }
}
</script>
